import { PluginNames } from '@/model'
import { Extension } from '@tiptap/react'

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    [PluginNames.CaseSwap]: {
      swapTextCase: () => ReturnType
    }
  }
}

interface CaseConvertQueueItem {
  from: number
  to: number
  text: string
  isAlreadyUppercase: boolean
}

export const CaseSwap = Extension.create({
  name: PluginNames.CaseSwap,

  addCommands() {
    return {
      swapTextCase:
        () =>
        ({ chain, editor }) => {
          const selection = editor.state.selection
          const content = selection.content()
          const queue: Array<CaseConvertQueueItem> = []

          content.content.descendants((node, pos) => {
            if (!node.isText || !node.text) return

            const text = node.text
            const from = selection.from + pos - 1
            const to = from + node.nodeSize
            const isAlreadyUppercase = text === text.toLocaleUpperCase()

            queue.unshift({ from, to, text, isAlreadyUppercase })
          })

          const convertToUppercase = queue.some(({ isAlreadyUppercase }) => !isAlreadyUppercase)

          queue.forEach(({ from, to, text }) => {
            const finalText = convertToUppercase
              ? text.toLocaleUpperCase()
              : text.toLocaleLowerCase()
            chain().insertContentAt({ from, to }, finalText)
          })

          return chain().run()
        },
    }
  },

  addKeyboardShortcuts() {
    return {
      'Mod-Shift-U': () => {
        return this.editor.commands.swapTextCase()
      },
    }
  },
})
